// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__yA9eg","title":"BackImages_title__2ERjz","images":"BackImages_images__1DzRt"};